import { useCheckForSalesRestrictions } from 'src/modules/register/composables/sales-restrictions/check-for-sales-restrictions'
import { useGlobalProperties } from 'src/modules/register/composables/sales-restrictions/global-properties'

export function useSalesRestrictions () {
  const { checkForSalesRestrictions } = useCheckForSalesRestrictions()
  const globalProperties = useGlobalProperties()

  return {
    checkForSalesRestrictions,
    globalProperties
  }
}
